const updateItem = async (data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Items/UpdateItem`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    });

    if (response.ok) {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        return await response.json(); // Parse as JSON if the content type is JSON
      } else {
        const textResponse = await response.text(); // Parse as text for other content types
        return { message: textResponse }; // Return a JSON object with the text message
      }
    } else {
      const errorData = await response.json();
      console.error("Bad Request:", errorData);
    }
  } catch (err) {
    console.error(err);
    return null;
  }
};

export default updateItem;
